import React, { useEffect, useState } from "react";
import AppShell from "../../components/layout/AppShell";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { CurrencyInr, CheckCircle } from "@phosphor-icons/react";

export default function DistancePricing() {
  const [data, setData] = useState({ base_distance: 0, price_per_km: 0 });
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get("/pricing/distance").then(r => setData(r.data)).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/pricing/distance", {
        base_distance: Number(data.base_distance),
        price_per_km: Number(data.price_per_km),
      });
      toast.success("Distance pricing saved");
      setSaved(true);
      setTimeout(() => setSaved(false), 1500);
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <AppShell title="Distance Pricing" subtitle="Service & Pricing">
      <div className="max-w-xl bg-white border border-[#E5E2D9] rounded-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-md bg-[#2D5A27]/10 flex items-center justify-center">
            <CurrencyInr size={20} color="#2D5A27" weight="fill" />
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#8A8780]">Formula</div>
            <div className="font-heading text-lg">billable = max(0, distance − base) × price/km</div>
          </div>
        </div>
        <form onSubmit={save} className="space-y-4" data-testid="distance-form">
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-[#5C5A55] block mb-2">Base distance (km) — free</label>
            <input data-testid="dp-base" type="number" step="any" min="0" required
                   value={data.base_distance}
                   onChange={(e) => setData(d => ({ ...d, base_distance: e.target.value }))}
                   className="w-full h-10 px-3 border border-[#E5E2D9] rounded-md font-mono" />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-[#5C5A55] block mb-2">Price per km (₹)</label>
            <input data-testid="dp-price" type="number" step="any" min="0" required
                   value={data.price_per_km}
                   onChange={(e) => setData(d => ({ ...d, price_per_km: e.target.value }))}
                   className="w-full h-10 px-3 border border-[#E5E2D9] rounded-md font-mono" />
          </div>
          <button data-testid="dp-save" type="submit"
                  className="w-full h-10 bg-[#2D5A27] hover:bg-[#3A7033] text-white rounded-md text-sm font-medium inline-flex items-center justify-center gap-2">
            {saved ? <CheckCircle size={14} weight="bold" /> : null}
            {saved ? "Saved" : "Save"}
          </button>
        </form>
        <div className="mt-6 pt-6 border-t border-[#E5E2D9] text-xs text-[#5C5A55]">
          No manual override allowed. Total price is always calculated server-side
          using these rates.
        </div>
      </div>
    </AppShell>
  );
}
